import { css } from '@emotion/react';
import style from './field.style';

const field = css`
  ${style.field}
  overflow: hidden;
  div {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const editableField = css`
  ${style.editableField}
  overflow: hidden;
  div {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const editIcon = css`
  ${style.editIcon}
`;

const modal = css`
  ${style.modal}
`;

const modalContent = css`
  ${style.modalContent};
  &&& {
    padding: 0 !important;
    flex-direction: column;
    max-height: 450px;
    overflow: unset;
    > div {
      overflow: unset;
    }
  }
`;

const inputContainer = css`
  &&&& {
    > div {
      width: 100%;
    }
    input {
      border-color: var(--saa-primary-color-10);
    }
  }
`;

const input = css`
  &&&&&& {
    input {
      line-height: 1.21428571em;
      padding: 0.67857143em 2.1em 0.67857143em 1em;
      font-size: 1.143rem;
    }
  }
`;

const nameContainer = css`
  ${input};
  ${inputContainer};
  padding-top: 10px;
  .ui.left.corner.label:after {
    top: -1px;
  }
`;

const actions = css`
  display: flex;
  justify-content: flex-end;
`;

const button = css`
  ${style.button}
  flex: 1;
  min-width: max-content;
  max-width: 120px;
`;

const subTitle = css`
  ${style.subTitle}
`;

const valueContainer = css`
  ${style.valueContainer}
`;

const value = css`
  ${style.value}
`;

const actionPlanCoordinatorList = css`
  padding: 0 10px;
  margin: 5px 0;
  min-height: 123px;
`;
const actionPlanCoordinatorItem = css`
  padding: 5px 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  &:not(:last-of-type) {
    border-bottom: 1px solid var(--saa-primary-color-20);
  }

  && {
    button {
      margin-left: auto;
      border-radius: 20px;
      background-color: var(--saa-white-color);
    }
  }
`;

const actionPlanCoordinatorInfo = css`
  padding-left: 5px;
`;
const actionPlanCoordinatorEmail = css`
  word-break: break-word;
`;
const actionPlanCoordinatorName = css`
  font-size: 0.8rem;
`;
const actionPlanCoordinatorRole = css`
  font-size: 0.8rem;
`;

const addCoordinatorButton = css`
  display: flex;
  justify-content: center;
`;

const formButtons = css`
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;
`;
const addCoordinatorForm = css`
  &&& {
    padding: 10px;
  }
  border-bottom: 1px solid var(--saa-primary-color-40);
`;

const disclaimer = css`
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0 10px 5px;
`;

export default {
  field,
  editableField,
  modal,
  modalContent,
  actions,
  button,
  editIcon,
  nameContainer,
  subTitle,
  valueContainer,
  value,
  actionPlanCoordinatorList,
  actionPlanCoordinatorItem,
  actionPlanCoordinatorInfo,
  actionPlanCoordinatorEmail,
  actionPlanCoordinatorName,
  actionPlanCoordinatorRole,
  addCoordinatorButton,
  formButtons,
  addCoordinatorForm,
  input,
  disclaimer,
};
